<template>
  <div class="inventory-container">
    <!-- 搜索区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="searchForm" class="filter-form">
        <el-form-item label="货品名称">
          <el-input
            v-model="searchForm.goods_name"
            placeholder="请输入货品名称"
            clearable
            @keyup.enter.native="handleSearch"
            style="width: 240px;"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button type="success" icon="el-icon-refresh" @click="refreshData">刷新</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 统计区域 -->
    <el-row :gutter="20" class="stat-row">
      <el-col :span="8">
        <el-card shadow="never" class="stat-card">
          <div class="stat-item">
            <span class="stat-label">总货品种类数</span>
            <span class="stat-value">{{ totalCount }}</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never" class="stat-card">
          <div class="stat-item">
            <span class="stat-label"> 账面总库存</span>
            <span class="stat-value">{{ totalnum }}</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never" class="stat-card">
          <div class="stat-item">
            <span class="stat-label"> 账面总成本</span>
            <span class="stat-value amount">￥{{ totalAmount }}</span>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="list"
        border
        stripe
        style="width: 100%"
        @row-click="handleRowClick"
        max-height="500"
      >
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="goods_name" label="货品名" min-width="200">
          <template slot-scope="scope">
            <span class="goods-name-cell">
              {{ scope.row.goods_name || '未命名' }}
              <span v-if="scope.row.comlist_v1" class="spec-tag">
                （{{ scope.row.comlist_v1 }}）
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="comlist_s1" label="剩余数量" width="130" align="center">
          <template slot-scope="scope">
            <span class="number-cell">{{ scope.row.comlist_s1 ?? 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="剩余重量" width="140" align="center">
          <template slot-scope="scope">
            {{ formatWeight(scope.row.comlist_s2 || 0) }}
          </template>
        </el-table-column>
        <el-table-column prop="comlist_f1" label="成本价" width="130" align="right">
          <template slot-scope="scope">
            <span class="price-cell">{{ formatPrice(scope.row.comlist_f1) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cost" label="账面成本" width="160" align="right">
          <template slot-scope="scope">
            <span class="price-cell amount">{{ formatPrice(scope.row.cost) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fenzu" label="货品分组" min-width="140" align="center">
          <template slot-scope="scope">
            <el-tag size="small" type="info">
              {{ scope.row.fenzu || '默认分组' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 货品详情弹窗 -->
    <el-dialog
      title="货品详情"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-descriptions :column="2" border v-if="currentItem">
        <el-descriptions-item label="货品名称">
          {{ currentItem.goods_name || '未命名' }}
        </el-descriptions-item>
        <el-descriptions-item label="规格">
          {{ currentItem.comlist_v1 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="剩余数量">
          {{ currentItem.comlist_s1 ?? 0 }}
        </el-descriptions-item>
        <el-descriptions-item label="剩余重量">
          {{ formatWeight(currentItem.comlist_s2 || 0) }}
        </el-descriptions-item>
        <el-descriptions-item label="成本价">
          {{ formatPrice(currentItem.comlist_f1) }}
        </el-descriptions-item>
        <el-descriptions-item label="账面成本">
          <span class="price-cell amount">{{ formatPrice(currentItem.cost) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="货品分组" :span="2">
          {{ currentItem.fenzu || '默认分组' }}
        </el-descriptions-item>
        <el-descriptions-item label="货品ID" :span="2">
          {{ currentItem.goods_id || '-' }}
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'InventoryQuery',
  data () {
    return {
      loading: false,
      searchForm: {
        goods_name: ''
      },
      list: [],
      totalCount: 0,
      totalAmount: 0,
      totalnum: 0,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      pages: 0,
      dialogVisible: false,
      currentItem: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // ----- 数据请求 -----
    async getKucunList (isLoadMore = false) {
      if (this.loading) return

      this.loading = true
      try {
        const shopId = localStorage.getItem('sh_id')
        if (!shopId) {
          this.$message.warning('请先选择店铺')
          this.loading = false
          return
        }

        const requestData = {
          sh_id: parseInt(shopId),
          page: this.currentPage,
          page_size: this.pageSize,
          a: 'lists'
        }

        if (this.searchForm.goods_name && this.searchForm.goods_name.trim() !== '') {
          requestData.goods_name = this.searchForm.goods_name.trim()
        }
        const response = await request.post('/goods/kucun_display.php', requestData)
        const res = response
        if (res && res.code === '0') {
          this.pages = res.pages || 1
          this.totalCount = res.goods_num || 0
          this.totalAmount = res.amount || 0
          this.totalnum = res.kucun || 0
          this.total = (res.pages || 1) * this.pageSize

          const rawList = res.data || []
          const formattedList = rawList.map(item => ({ ...item }))

          if (isLoadMore) {
            this.list = [...this.list, ...formattedList]
          } else {
            this.list = formattedList
          }
        } else {
          this.$message.error(res?.msg || '获取库存数据失败')
          if (!isLoadMore) {
            this.list = []
            this.total = 0
          }
        }
      } catch (error) {
        console.error('库存数据请求异常:', error)
        this.$message.error('网络错误，请稍后重试')
        if (!isLoadMore) {
          this.list = []
          this.total = 0
        }
      } finally {
        this.loading = false
      }
    },

    loadData () {
      this.currentPage = 1
      return this.getKucunList(false)
    },

    // ----- 搜索 / 重置 / 刷新 -----
    handleSearch () {
      this.currentPage = 1
      this.getKucunList(false)
    },

    handleReset () {
      this.searchForm.goods_name = ''
      this.currentPage = 1
      this.getKucunList(false)
    },

    refreshData () {
      this.getKucunList(false)
    },

    // ----- 分页 -----
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getKucunList(false)
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.getKucunList(false)
    },

    // ----- 行点击 -----
    handleRowClick (row) {
      this.currentItem = row
      this.dialogVisible = true
    },

    // ----- 格式化工具 -----
    formatPrice (val) {
      if (val === undefined || val === null || val === '') return '￥0.00'
      if (val === '--') return '--'
      return '￥' + Number(val).toFixed(2)
    },

    formatWeight (val) {
      if (val === undefined || val === null || val === '') return '0.0 kg'
      if (val === '--') return '--'
      return Number(val).toFixed(1) + ' kg'
    }
  }
}
</script>

<style lang="scss" scoped>
.inventory-container {
  padding: 0 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .page-header {
    padding: 16px 0 8px 0;

    h2 {
      margin: 0;
      font-size: 22px;
      font-weight: 600;
      color: #303133;
      letter-spacing: 1px;

      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 22px;
        background: #409eff;
        border-radius: 2px;
        margin-right: 12px;
        vertical-align: middle;
      }
    }
  }

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;

      .el-form-item {
        margin-bottom: 0;
      }
    }
  }

  .stat-row {
    margin-bottom: 20px;

    .stat-card {
      .stat-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 4px 0;

        .stat-label {
          font-size: 15px;
          color: #606266;
        }

        .stat-value {
          font-size: 26px;
          font-weight: 700;
          color: #303133;

          &.amount {
            color: #ee530c;
          }
        }
      }
    }
  }

  .table-card {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }

    .goods-name-cell {
      font-weight: 500;
      color: #303133;

      .spec-tag {
        color: #909399;
        font-weight: 400;
        font-size: 13px;
      }
    }

    .number-cell {
      font-weight: 500;
      color: #409eff;
    }

    .price-cell {
      font-family: 'Courier New', monospace;
      font-weight: 500;

      &.amount {
        color: #ee530c;
      }
    }
  }

  // 覆盖 el-table 行点击样式
  ::v-deep .el-table__row {
    cursor: pointer;

    &:hover {
      background-color: #ecf5ff !important;
    }
  }

  // 统计卡片 hover 效果
  .stat-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
  }
}
</style>
